var quantityLabel = "Määrä";
var quantityFlyoutHeader = "Valitse haluamasi määrä";
var quantityFlyoutCTA = "Valitse tämä määrä";
var closeButton = "Sulje";
var pricePlaceholder = "...";
var priceLabel = "Hinta";
var unitPriceLabel = "Yksikköhinta";
var incompatibilityMessage = "Ei saatavilla muiden valintojen kohdalla: ";
var select = "Valitse...";
var percentSavings = "{{{PERCENT}}} %:n säästöt";
var sale = "Ale";
var amountSavings = "{{{AMOUNT}}} %:n säästöt/kpl";
var amountSavingsWithSale = "{{{AMOUNT}}} %:n säästöt/kpl + ale";
var seeMoreQuantities = "Katso lisää kappalemääriä";
var required = "Vaaditaan";
var sample = "Näytekappale";
var estimatedQuantity = "Arvioitu määrä";
var numberOfRecipients = "{{{COUNT}}} Vastaanottajat";
var recommendedCallout = "Suositellut";
var newCallout = "Uutta";
var incompatibleLabel = "Yhteensopimaton";
var outOfStockCallout = "Tilapäisesti lopussa";
var dismissAlert = "Ohita ilmoitus";
var unwindingMessage_1 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}} ja {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} ja {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Yhteensopimaton useamman kuin {{{ATTRIBUTE_COUNT}}} vaihtoehdon kanssa.";
var unwindingAlertMessage_1 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} poistettu.";
var unwindingAlertMessage_2 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} ja {{{ATTRIBUTE2}}} {{{OPTION2}}} poistettu.";
var unwindingAlertMessage_3 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} ja {{{ATTRIBUTE3}}} {{{OPTION3}}} poistettu.";
var unwindingAlertMessage_more = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: Useampi kuin {{{ATTRIBUTE_COUNT}}} vaihtoehtoa poistettu.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} vastaanottaja {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Vähintään {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Syötä arvo väliltä {{{MINIMUM}}}–{{{MAXIMUM}}} sivua, kansi mukaan lukien ";
var rangePartialRangedHelperTextForBooklets = "Vähintään {{{MINIMUM}}} sivua, kansi mukaan lukien ";
var rangedGeneralInputError = "Tieto on virheellinen";
var rangedBetweenRangesError = "Lähimmät numerot ovat {{{LOWER}}} {{{UNIT}}} ja {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Luku ei saa ylittää kahdeksaa desimaalia";
var rangedMinInputValueError = "Vähimmäisluku on {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Enimmäisluku on {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Syötteen on oltava numero";
var requiredAttributeFieldError = "Anna arvo välillä {{{LOWER}}} ja {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Lähimmät numerot ovat {{{LOWER}}} sivua ja {{{HIGHER}}} sivua ";
var rangedMinInputValueErrorForBooklets = "Vähimmäisluku on {{{MINIMUM}}} sivua ";
var rangedMaxInputValueErrorForBooklets = "Enimmäisluku on {{{MAXIMUM}}} sivua ";
var requiredAttributeFieldErrorForBooklets = "Syötä arvo väliltä {{{LOWER}}}–{{{HIGHER}}} sivua, kansi mukaan lukien ";
var requiredInformationToast = "Anna kaikki tarvittavat tiedot.";
var fiFi = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, fiFi as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=fi-fi.json.mjs.map
